
import FullPageLoader from '@common/FullPageLoader';
import { useState,useEffect } from 'react';
import { sendOtpToForgotPassword,otpVerifiedToForgotPassword,addNewPasswordToForgotPassword } from "@src/store/slices/user";
import { useNavigate,Link } from 'react-router-dom';
import { Tab, Nav } from 'react-bootstrap';
import ReactSlider from '@src/common/ReactSlider';
import loginlogo from '../styles/webroot/images/login_logo.png'
import { MAX_OTP_TIMER, REGEX_EMAIL } from '@src/config/constant';
// import MobileUser from '@src/component/auth/MobileUser'
import { COUNTRY_CODE } from '@src/config/constant';

const isCountryId = COUNTRY_CODE ==='id' ? true : false


const loginLeft = {
    backgroundImage: `url("/images/login_bg_pattern.png")`,
    backgroundColor: "#008CF0",
    backgroundRepeat: "repeat-y",
    backgroundPosition: "center",
    borderRadius: "25px"
}

function ForgotPassword() {

    // eslint-disable-next-line
    const [showMobileLinks, setShowMobileLinks] = useState(false);
    // eslint-disable-next-line
    const [showEmailLinks, setShowEmailLinks] = useState(true);

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // eslint-disable-next-line
    const [showCaptcha, setShowCaptcha] = useState(0);


    const [inputField, setInputField] = useState({
        email: "",
        password: "",
        confirm_password:"",
        otp : "",
    });
    const [errField, setErrField] = useState<any>({
        email: "",
        isCaptchaInvalid: false,
        captchaError: "",
        captcha: "",
    });

    const [showVerify, setShowVerify] = useState<boolean>(false);
    const [showCreatePassword, setShowCreatePassword] = useState<boolean>(false);
    // eslint-disable-next-line
    const [userId, setUserId] = useState<string>('');
    // eslint-disable-next-line
    const [reloadCaptcha, setReloadCaptcha] = useState(1);
    const maxTime = MAX_OTP_TIMER;
    const [otpTimer, setOtpTimer] = useState(maxTime);
    // eslint-disable-next-line
    const [showPassword, setShowPassword] = useState(false);

    const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setInputField({ ...inputField, [name]: value });
        errField[name] = '';
        setErrField({ ...errField });
    };

    const activeTabHandler = (selectedtab: any) => {
        setShowCaptcha((prev)=>prev+1);
    }


    const validEmailRegex = RegExp(REGEX_EMAIL); // eslint-disable-line

    const validForm = () => {
        let formIsValid = true;
        setErrField({
            email: "",
            otp: "",
            password: "",
            confirm_password:"",
        });

        if(!showVerify){
            if (inputField.email === "") {
    
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    email: "Email is required",
                }));
            } else if (!validEmailRegex.test(inputField.email)) {
    
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    email: "Please enter valid email",
                }));
            }
        }


        if (showVerify) {
            if (inputField.otp === "" || inputField.otp.trim() === '') {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    otp: 'OTP is required',
                }));
            }
        }

        if(showCreatePassword) {
            const password_regex = /^.{8,}$/;
            if (inputField.password === "" || inputField.password.trim() === "") {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    password: "Password is required",
                }));
            }else if (!password_regex.test(inputField.password)) {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    password: "Password should be at least 8 characters long",
                }));
            }

            if (inputField.confirm_password === "" || inputField.confirm_password.trim() === "") 
            {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    confirm_password: "Confirm password is required",
                }));
            }

            if (inputField.password !== "" && inputField.confirm_password !== "" && inputField.password !== inputField.confirm_password) 
            {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    confirm_password: "Passwords do not match",
                }));
            }
        }

        return formIsValid;
    };

    const submitButton = async () => {
        setLoading(true);
        if (validForm()) {
            let data = {
                email : inputField.email,
            }
            sendOtpToForgotPassword(data).then((res) => {
                setLoading(false)
                if (res && res.data) {
                    //DELETE CAPTCHA HASH FROM CACHE 
                    setUserId(res && res.data && res.data.user_id);
                    setShowVerify(true);

                }
                setReloadCaptcha((prev) => prev + 1)
                setInputField({ ...inputField, email: inputField.email})

            });
        } else {
            setReloadCaptcha((prev) => prev + 1)
            setLoading(false);
        }
    }

    const verifyOtp = async () => {
        setLoading(true);
        if (validForm()) {
            let data = {email : inputField.email , otp : inputField.otp}
            otpVerifiedToForgotPassword(data).then((res) => {
                setLoading(false)
                if (res && res.data) {
                    setShowVerify(false);
                    setShowCreatePassword(true);
                }

            });
        } else {
            setReloadCaptcha((prev) => prev + 1)
            setLoading(false);
        }
    }

    const createNewPassword = async () => {
        setLoading(true);
        if (validForm()) {
            let data = {email : inputField.email , password : inputField.password, confirm_password : inputField.confirm_password}
            addNewPasswordToForgotPassword(data).then((res) => {
                setLoading(false)
                if (res && res.data) {
                    setInputField({
                        email: "",
                        password: "",
                        confirm_password:"",
                        otp:""

                    });
                    setShowVerify(false);
                    setShowCreatePassword(false);
                    navigate('/login');
                }

            });
        }else{
            setLoading(false);
        }
    }

    const resendOtp = () => {
        if (otpTimer < 0) {
            let data = {email : inputField.email}
            sendOtpToForgotPassword(data).then((res) => {
                setLoading(false)
                if (res && res.data) {
                    //DELETE CAPTCHA HASH FROM CACHE 
                    setUserId(res && res.data && res.data.user_id);
                    setShowVerify(true);

                }
                setReloadCaptcha((prev) => prev + 1)
                setInputField({ ...inputField, email: inputField.email })
                setOtpTimer(maxTime);
            });
        }
    }

    useEffect(() => {
        let startInterval: NodeJS.Timeout;
        if (otpTimer >= 0) {

            startInterval = setInterval(() => {
                setOtpTimer((val) => val - 1)

            }, 1000)
        } else {
            setOtpTimer(-1)
        }

        return () => {
            clearInterval(startInterval)

        }
    }, [otpTimer])

    // const handleClickShowPassword = () => {
    //     let pwdstatus=(showPassword)?false:true;
    //     setShowPassword(pwdstatus);
    // }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="login-outer">
                    <div className="login-left-panel" style={loginLeft}>
                        <div className="login-bg" style={{background: "none"}}>
                            <div className="login-txt t-center t-center ocr-login-left">
                                <span>Welcome.</span>
                                <h1> Please sign in to Zen Insure</h1>
                            </div>
                            {/* <img src={'/images/ocr_login_bg.png'} className="login-bg-img ocr-login-bg" alt='logo-bg' /> */}
                            <ReactSlider screenType="Login"></ReactSlider>
                        </div>
                    </div>
                    <div className="login-right-panel t-center">
                        <div className="logo-img m-xl-b">
                            <img src={loginlogo} className="" alt='logo' />
                        </div>
                        {
                            showCreatePassword ? (
                                <div className="login-heading">
                                    <h2>Create New Password</h2>
                                </div>
                            ) : showVerify ? (
                                <div className="login-heading">
                                    <h2 className="otp-heading">Verify OTP</h2>
                                    <small className="otp-subheading">Enter the OTP sent to your registered email ID</small>
                                    <small className="otp-email">{inputField.email}</small>
                                </div>
                            ) : (
                                <div className="login-heading">
                                    <h2>Forgot Password</h2>
                                </div>
                            )
                        }
                        <Tab.Container id="" defaultActiveKey="first" >
                            <div className="login-tab"> 
                                {
                                 !isCountryId && 
                                     <Nav variant="pills" className="flex-column" onSelect={(k) => activeTabHandler(k)}>
                                {(showEmailLinks && showMobileLinks) &&
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">By Email</Nav.Link>
                                    </Nav.Item>
                                }
                                {(showEmailLinks && showMobileLinks) &&
                                    <Nav.Item>
                                        <Nav.Link eventKey="second">By Mobile</Nav.Link>
                                    </Nav.Item>
                                }
                                </Nav>
                                }
                               


                                <Tab.Content>
                                    

                                    <Tab.Pane eventKey="second">
                                        {/* <MobileUser setShowEmailLinks = {setShowEmailLinks} setShowMobileLinks = {setShowMobileLinks} showCaptcha={showCaptcha}/>  */}
                                    </Tab.Pane>  

                                    <Tab.Pane eventKey="first">
                                        <div className="login-form">

                                            <FullPageLoader show={loading} />

                                            {
                                                showCreatePassword ? 
                                                (
                                                    <form autoComplete="on">
                                                        <fieldset className="">
                                                            <div className={"material " + (errField.password ? "error" : "")}>
                                                                <input
                                                                     type={(showPassword)?"text":"password"}
                                                                    placeholder=" "
                                                                    name="password"
                                                                    value={inputField.password}
                                                                    className="form-input password-txt"
                                                                    onChange={inputHandler}
                                                                />
                                                                <i className="ic-password icn-login"></i>
                                                                <label data-label="New Password" className="form-label"></label>
                                                                {errField.password && (
                                                                    <span className="error-txt">
                                                                        {errField['password'] || ""}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </fieldset>
                                                        <fieldset className="">
                                                            <div className={"material " + (errField.confirm_password ? "error" : "")}>
                                                                <input
                                                                     type={(showPassword)?"text":"password"}
                                                                    placeholder=" "
                                                                    name="confirm_password"
                                                                    value={inputField.confirm_password}
                                                                    className="form-input password-txt"
                                                                    onChange={inputHandler}
                                                                />
                                                                <i className="ic-password icn-login"></i>
                                                                <label data-label="Confirm Password" className="form-label"></label>
                                                                {errField.confirm_password && (
                                                                    <span className="error-txt">
                                                                        {errField['confirm_password'] || ""}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </fieldset>
                                                        <div className="language-selectors">
                                                            <button type="button" className="btn-primary w-100" onClick={createNewPassword} disabled={loading}>
                                                                Save
                                                            </button>
                                                        </div>
                                                    </form>
                                                ):
                                                showVerify ?
                                                (   
                                                    <div>
                                                        <fieldset className="">
                                                            <div className = "material">
                                                                <input
                                                                    type="number"
                                                                    placeholder=" "
                                                                    name="otp"
                                                                    className="form-input "
                                                                    onChange={inputHandler}
                                                                />
                                                                <i className="ic-otp icn-login">
                                                                    <i className='path1'></i>
                                                                    <i className='path2'></i>
                                                                    <i className='path3'></i>
                                                                    <i className='path4'></i>
                                                                </i>

                                                                <label data-label='Otp' className="form-label"></label>
                                                                {errField.otp && (
                                                                    <span className="error-txt">
                                                                    {errField['otp'] || ""}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {
                                                                <p onClick={resendOtp} className={`resend-otp-txt ${otpTimer < 0 ? 'resend-otp' : ''}`}>{otpTimer < 0 ? 'Resend Otp' : 'resend otp after '+(otpTimer > 9 ? "0:" + otpTimer : "0:0" + otpTimer)+" seconds" }</p>
                                                            }

                                                        </fieldset>

                                                        <button type="button" className="btn-primary w-100" onClick={verifyOtp} disabled={loading}>
                                                            Verify
                                                        </button>

                                                    </div>
                                                )
                                                :
                                                    <form autoComplete="on">
                                                        <fieldset className="">
                                                            <div className={"material " + (errField.email ? "error" : "")}    >
                                                                <input
                                                                    type="text"
                                                                    placeholder=" "
                                                                    name="email"
                                                                    value={inputField.email}
                                                                    className="form-input"
                                                                    onChange={inputHandler}
                                                                />
                                                                <i className="ic-email1 icn-login"></i>
                                                                <label data-label="Email" className="form-label"></label>
                                                                {errField.email && (
                                                                    <span className="error-txt">
                                                                        {errField['email'] || ""}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </fieldset>
                                                        
                                                        <div className="language-selectors">
                                                            <button type="button" className="btn-primary w-100" onClick={submitButton} disabled={loading}>
                                                                Send OTP
                                                            </button>
                                                        </div>
                                                        <div className="login-link-container">
                                                            <Link to="/login" className="login-link">
                                                                Log in
                                                            </Link>
                                                        </div>
                                                    </form>
                                            }
                                        </div> 
                                    </Tab.Pane>  

                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </div>
    )

}


export default ForgotPassword